import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Dropdown, Form, Header, Modal } from 'semantic-ui-react';
import {
  closeUpdateBusinessEntityModal,
  setBusinessEntityTypeInput,
  setBusinessEntityTypeError,
  updateBusinessEntityType,
} from 'state/business/actions';
import { BUSINESS_ENTITY_TYPE_OPTIONS } from './constant';

export const EditBusinessEntityModal = props => {
  const {
    updateBusinessEntityModal,
    allBusiness,
    businessDetailsData,
    businessEntityTypeInput,
    businessEntityTypeError,
    updatingBusinessEntityType,
    dispatch,
  } = props;

  const activeBusiness = businessDetailsData.data;

  const handleOnCancelButtonClick = () => {
    dispatch(closeUpdateBusinessEntityModal());
  };

  const handleOnBusinessEntityTypeChange = (e, { value }) => {
    dispatch(setBusinessEntityTypeInput(value));
    dispatch(setBusinessEntityTypeError(null));
  };

  const handleOnSaveButtonClick = () => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    dispatch(
      updateBusinessEntityType({
        businessId,
        businessEntityType: businessEntityTypeInput,
      })
    );
  };

  return (
    <Modal
      size="tiny"
      open={updateBusinessEntityModal}
      onClose={handleOnCancelButtonClick}
    >
      <Header icon="building" content="Edit Business Entity" />
      <Modal.Content>
        {activeBusiness ? (
          <Form>
            <Form.Field>
              <label>Business ID</label>
              <input value={activeBusiness.id} disabled />
            </Form.Field>
            <Form.Field>
              <label>Business Name</label>
              <input value={activeBusiness.name} disabled />
            </Form.Field>
            <Form.Field>
              <label>Address</label>
              <input value={activeBusiness.address} disabled />
            </Form.Field>
            <Form.Field>
              <label>Subscription</label>
              <input value={activeBusiness.business_subscription[0]} disabled />
            </Form.Field>
            <Form.Field>
              <label>Registered Date</label>
              <input value={activeBusiness.registered_date} disabled />
            </Form.Field>
            <Form.Field>
              <label>Expiration</label>
              <input value={activeBusiness.expired_at} disabled />
            </Form.Field>
            <Form.Field>
              <label>Is Deleted</label>
              <input value={activeBusiness.is_deleted.toString()} disabled />
            </Form.Field>
            <Form.Field>
              <label>Business Entity Type</label>
              <Dropdown
                selection
                placeholder="Select entity type"
                options={BUSINESS_ENTITY_TYPE_OPTIONS}
                value={businessEntityTypeInput}
                onChange={handleOnBusinessEntityTypeChange}
                error={!!businessEntityTypeError}
              />
            </Form.Field>
            {businessEntityTypeError && (
              <div style={{ color: '#9f3a38', marginTop: '-0.5em' }}>
                {businessEntityTypeError}
              </div>
            )}
          </Form>
        ) : (
          <></>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="green"
          loading={updatingBusinessEntityType}
          disabled={
            !businessEntityTypeInput ||
            updatingBusinessEntityType ||
            (!!activeBusiness &&
              businessEntityTypeInput === activeBusiness.business_entity_type)
          }
          onClick={handleOnSaveButtonClick}
        >
          Save
        </Button>
        <Button
          basic
          color="black"
          disabled={updatingBusinessEntityType}
          onClick={handleOnCancelButtonClick}
        >
          Cancel
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ business }) => ({
  updateBusinessEntityModal: business.updateBusinessEntityModal,
  allBusiness: business.allBusiness,
  businessDetailsData: business.businessDetailsData,
  businessEntityTypeInput: business.businessEntityTypeInput,
  businessEntityTypeError: business.businessEntityTypeError,
  updatingBusinessEntityType: business.updatingBusinessEntityType,
});

EditBusinessEntityModal.propTypes = {
  updateBusinessEntityModal: PropTypes.bool.isRequired,
  allBusiness: PropTypes.object.isRequired,
  businessDetailsData: PropTypes.object.isRequired,
  businessEntityTypeInput: PropTypes.string.isRequired,
  businessEntityTypeError: PropTypes.string,
  updatingBusinessEntityType: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

EditBusinessEntityModal.defaultProps = {
  businessEntityTypeError: null,
};

export default connect(mapStateToProps)(EditBusinessEntityModal);
